import { Box, BoxProps, CheckBox, ColorOptions, Icon, Image, TextNew, TextNewProps } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'
import { View } from 'react-native'
import sort_inactive from '../../assets/images/sort_inactive.png'

interface ListHeadProps {
  sizeConfig: Array<number>
  headTitle: Array<any>
  onSort?: (key: any) => void
  sortData?: any
  showExpandArrow: boolean
  isColumnSearchEnabled?: boolean
  onSearchTextChange?: any
  type: string
  onAllChecked?: (isAllChecked) => void
  isAllChecked?: boolean
  apiSortOrder?: any
  columnsWidth?: any
  headerTextStyle?: TextNewProps
}

const ListHead = ({
  sizeConfig,
  headTitle,
  onSort,
  sortData,
  showExpandArrow,
  isColumnSearchEnabled = false,
  onSearchTextChange,
  type,
  onAllChecked,
  isAllChecked,
  apiSortOrder,
  columnsWidth,
  headerTextStyle,
}: ListHeadProps) => {
  const [hover, setHover] = useState<{ isHovering: boolean; value: string }>({ isHovering: false, value: '' })
  const onPress = (item: any) => {
    onSort && onSort(Object.keys(item)[0])
  }

  const getOrder = (item: any) => {
    let order = ''
    if (apiSortOrder) {
      const keyValueMap = {
        id: 'id',
        createdAt: 'createdAt',
        eccCreatedAt: 'eccCreatedAt',
      }
      if (keyValueMap[Object.keys(item)?.[0]]) {
        order = 'NONE'
      }
      const orderArr = apiSortOrder?.find((obj) => keyValueMap[obj?.[0]] === Object.keys(item)?.[0]) ?? []
      if (orderArr?.length > 0) {
        order = orderArr[1]
      }
    } else {
      order = sortData?.filter(
        (sortItem: any) =>
          sortItem.key.toLowerCase().replace(' ', '') === Object.keys(item)[0].toLowerCase().replace(' ', ''),
      )?.[0]?.order
    }

    const orderMap = {
      asc: 'ARROW_UP',
      desc: 'ARROW_DOWN',
      NONE: 'image',
    }
    return orderMap[order]
  }

  const handleColumnSearch = (label: string, searchText: string) => {
    if (onSearchTextChange) {
      onSearchTextChange(label, searchText)
    }
  }

  const handleCheckAll = (val) => {
    onAllChecked(val)
  }
  return (
    <View style={{ minWidth: 'min-content' }}>
      <Box
        {...styles.container}
        h={type === 'VPA' ? 32 : isColumnSearchEnabled ? 80 : 48}
        borderLeftWidth={type === 'SCROLLABLE' ? 1 : 0}
        borderRightWidth={type === 'SCROLLABLE' ? 1 : 0}
        borderTopWidth={type === 'SCROLLABLE' ? 1 : 0}
        borderColor={type === 'SCROLLABLE' ? 'GRAY_BORDER' : undefined}
        paddingLeft={showExpandArrow ? 64 : 'LARGE'}
        width={'100%'}
        bg={type === 'VPA' ? 'BG_PRIMARY' : 'WHITE'}
        overflow={'hidden'}
        ph={showExpandArrow ? 0 : 'LARGE'}>
        {headTitle.map((item, index) => (
          <Box
            f={sizeConfig?.[index]}
            flexDirection={'column'}
            h={type === 'VPA' ? 32 : isColumnSearchEnabled ? 80 : 48}
            w={type === 'SCROLLABLE' ? columnsWidth(Object.keys(item)[0]) : undefined}>
            <Box
              key={index}
              onPress={() => onPress(item)}
              disabled={isEmpty(item[Object.keys(item)[0]])}
              onHover={(hover) => setHover({ isHovering: hover, value: item[Object.keys(item)[0]] })}
              flexDirection="row"
              alignItems="center"
              h={type === 'VPA' ? 32 : 48}
              underlayColor="TRANSPARENT">
              {Object.keys(item)[0] === 'check' && <CheckBox checked={isAllChecked} onChecked={handleCheckAll} />}
              <TextNew
                type={'body14'}
                fontWeight={'BOLD'}
                fontSize={12}
                fontFamily={'jioType-bold'}
                textTransform={'capitalize'}
                color={'BLACK_21'}
                {...headerTextStyle}>
                {item[Object.keys(item)[0]]}
              </TextNew>
              {hover.isHovering &&
                item[Object.keys(item)[0]] === hover.value &&
                !isEmpty(hover.value) &&
                !!getOrder(item) && (
                  <>
                    {getOrder(item) === 'image' && <Image source={sort_inactive} width={16} height={16} />}
                    {getOrder(item) !== 'image' && (
                      <Icon id={getOrder(item)} size="FONT_SIZE_EXTRA_LARGE" color={'#6e707e' as ColorOptions} />
                    )}
                  </>
                )}
            </Box>
            {isColumnSearchEnabled && (
              <Box pr={8} h={32}>
                <TextInput
                  placeholderTextColor={'PRIMARY_GREY'}
                  onChangeText={(searchText) => handleColumnSearch(Object.keys(item)[0], searchText)}
                  fontSize={12}
                  fontWeight={'300'}
                  placeholder="Search"
                  fontFamily={'jiotype-medium'}
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </View>
  )
}

const styles = {
  container: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
}

export { ListHead }
